import { ResumeSectionType } from '@applicator/shared'

export interface ResumeSection {
  type: ResumeSectionType
  label: string
  icon?: string
}

export const RESUME_SECTIONS: ResumeSection[] = [
  { type: 'contact_info', label: 'Contact Information' },
  { type: 'target_title', label: 'Target Title' },
  { type: 'professional_summary', label: 'Professional Summary' },
  { type: 'work_experience', label: 'Work Experience' },
  { type: 'education', label: 'Education' },
  { type: 'skills', label: 'Skills' },
  { type: 'interests', label: 'Interests' },
  { type: 'certifications', label: 'Certifications' },
  { type: 'awards_scholarships', label: 'Awards & Scholarships' },
  { type: 'projects', label: 'Projects' },
]
